<template>
  <div class="appMain-warpper">
    <section class="app-main" :class="{ appMain2: URL === `publicWarning` }">
      <transition name="fade-transform" mode="out-in">
        <router-view :key="key" />
      </transition>
    </section>
  </div>
</template>

<script>
export default {
  name: "AppMain",
  data() {
    return {};
  },
  computed: {
    key() {
      // 只区分一级菜单（warningrelease/publicWarning/...），不区分子路由
      // 否则子路由切换会触发整个组件重建，破坏 keep-alive
      return this.$route.path.split("/").slice(0, 3).join("/");
    },
    URL() {
      return this.$route.path.split("/")[2];
    },
  },
};
</script>

<style lang="scss" scoped>
.appMain-warpper {
  height: 100%;
  .app-main {
    display: flex;
    width: 100%;
    height: 100%;
    flex: 1;
    min-width: 0;
    overflow: hidden;
    padding: vw(20) vw(15) vw(20) vw(15);
  }

  .appMain2 {
    padding: 0;
  }
}
</style>
